// @flow
import { useState, useEffect } from 'preact/hooks';
import { ComponentChildren, h, Fragment } from 'preact';
import { useWindowDimension } from '../../utils/useWindowDimension';
import { styled } from 'goober';

type Props = {
  handleCloseOverlay: Function,
  showOverlay: Boolean,
  overlaySizeClassName:
    | 'overlay-wd-small'
    | 'overlay-wd-medium'
    | 'overlay-wd-large',
  children: ComponentChildren,
};

const OverlayContainer = styled('div')`
  .overlay-wd-small,
  .overlay-wd-medium,
  .overlay-wd-large {
    max-width: 420px;
  }
  .containerWrapper {
    width: 100%;
    max-height: 100%;
    border-radius: 24px 24px 0px 0px;
  }

  .container {
    background-color: white;
    border-radius: 24px 24px 0px 0px;
    width: 100%;
    visibility: visible;
    transition: transform 0.257s ease-in-out;
    bottom: -2px;
  }

  .overlayBackdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    overflow: hidden;
    background: #666666;
    opacity: 0.5;
    z-index: 111;
  }

  .overlayContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    max-height: 460px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 999;
  }

  .closeButtonContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    padding: 5px;
    width: 23px;
    height: 23px;
    margin-right: 15px;
    margin-bottom: 5px;
    position: relative;
    top: 40px;
    z-index: 999;
  }

  .closeIcon {
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
  }
  .modelSlideIn {
    animation: slideInModalMobile 0.5s forwards;
  }

  @keyframes slideInModal {
    0% {
      transform: translate(-50%, 50%);
    }
  }

  @keyframes slideInModalMobile {
    0% {
      transform: translate(-50%, 100%);
    }
  }
`;
const OverlayBottomSheet = ({
  handleCloseOverlay,
  showOverlay,
  overlaySizeClassName,
  children,
  maxOverlayHeight,
  disabled,
}: Props) => {
  const [dimension] = useWindowDimension();
  const [width, height] = dimension;

  const Overlay_Height_Percentage = maxOverlayHeight || 0.75;
  const [overlayHeight, setOverLayHeight] = useState(
    height * Overlay_Height_Percentage,
  );
  useEffect(() => {
    setOverLayHeight(height * Overlay_Height_Percentage);
  }, [height]);

  return (
    <Fragment>
      <OverlayContainer>
        {showOverlay && <div className='overlayBackdrop' />}
        <div
          style={{
            maxHeight: overlayHeight,
          }}
          className='overlayContainer'>
          {navigator.onLine && (
            <div onClick={handleCloseOverlay} className='closeButtonContainer'>
              <span className='material-icons closeIcon'>close</span>
            </div>
          )}
          <div className='containerWrapper'>
            <div
              style={{
                transform: showOverlay ? 'translateY(0)' : 'translateY(100%)',
                display: showOverlay ? 'block' : 'none',
              }}
              className='container'
              showOverlay={showOverlay}>
              {children}
            </div>
          </div>
        </div>
      </OverlayContainer>
    </Fragment>
  );
};

export default OverlayBottomSheet;



// WEBPACK FOOTER //
// ./components/salesApp/OverlayBottomSheet.js